import { useMemo } from 'react';

import uniq from 'lodash/uniq';
import { FilterSelect, useSearchContext } from '@cast/shared-search-ui';

import { Cluster } from '@cast/types';
import { Box } from '@cast/design-system';

type ProjectFilterProps = {
  fullWidth?: boolean;
};

export const ProjectFilter = ({ fullWidth }: ProjectFilterProps) => {
  const searchCtx = useSearchContext<Cluster>();

  const options = useMemo(
    () =>
      uniq(
        (searchCtx?.data
          ?.map((cluster) => cluster.providerNamespaceId)
          .filter((id) => !!id) as string[]) || []
      ),
    [searchCtx?.data]
  );

  return (
    <Box sx={fullWidth ? { width: '100%' } : undefined}>
      <FilterSelect
        criterion="project"
        options={options}
        SelectProps={{ inputText: 'Project', size: 'md' }}
        multiple
        sx={{ width: '100%' }}
        testId="clusters-project-filter"
      />
    </Box>
  );
};
